import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var WishlistQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query wishlistQuery($userId: String = \"\") {\n    wishlist(wishlistRequest: { userId: $userId }) {\n      id\n      count\n      items {\n        id\n      }\n    }\n  }\n"])));
export default WishlistQuery;